import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';

/**
 * Generated class for the InforeconstructionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-inforeconstruction',
  templateUrl: 'inforeconstruction.html',
})
export class InforeconstructionPage {
  brandSap = ''
  title: any
  id: number
  proba = ''
  alias = ''
  brand = ''
  model = ''
  organisationid: number = 0
  organisationname = ''
  ids: any
  res = []

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN) {
    if (this.gn.user.ClientId == 711 || this.gn.user.ClientId == 357) {
      this.brandSap = this.dic.l["brandSapDic"]
    }
    else {
      this.brandSap = this.dic.l["brand"]
    }

    this.title = navParams.get('name')
    this.id = navParams.get('id')
    this.ids = navParams.get('ids')

    for (var j = 0; j < this.ids.length; j++) {
      var alias = this.gn.Vehicles[this.gn.VehiclesDic[this.ids[j]]].alias
      if (alias == null || alias == undefined || alias == '') {
        alias = '/'
      }
      var model = this.gn.Vehicles[this.gn.VehiclesDic[this.ids[j]]].model
      if (model == null || model == undefined || model == '') {
        model = '/'
      }
      var brand = this.gn.Vehicles[this.gn.VehiclesDic[this.ids[j]]].brand
      if (brand == null || brand == undefined || brand == '') {
        brand = '/'
      }
      var organisationid = this.gn.Vehicles[this.gn.VehiclesDic[this.ids[j]]].organisationid
      var organisationname = '';
      for (let i = 0; i < this.gn.Vehicles.length; i++) {
        if (this.ids[j] + '' == this.gn.Vehicles[i].vehicleid + '') {
          if (this.gn.Vehicles[i].organisationid == 0) {
            organisationname = this.dic.l['Ungroupped']
          } else {
            for (let j = 0; j < this.gn.Organisations.length; j++) {
              if (this.gn.Vehicles[i].organisationid == this.gn.Organisations[j].id && this.gn.Vehicles[i].organisationid != 0) {
                organisationname = this.gn.Organisations[j].name;
              }
            }
          }
        }
      }
      var registration = this.gn.Vehicles[this.gn.VehiclesDic[this.ids[j]]].registration + ' (' + this.gn.Vehicles[this.gn.VehiclesDic[this.ids[j]]].code + ')'
      this.res.push({ registration: registration, alias: alias, model: model, brand: brand, organisationid: organisationid, organisationname: organisationname })
    }


    // this.alias = this.gn.Vehicles[this.gn.VehiclesDic[this.id]].alias
    // if (this.alias == null || this.alias == undefined || this.alias == '') {
    //   this.alias = '/'
    // }
    // this.model = this.gn.Vehicles[this.gn.VehiclesDic[this.id]].model
    // if (this.model == null || this.model == undefined || this.model == '') {
    //   this.model = '/'
    // }
    // this.brand = this.gn.Vehicles[this.gn.VehiclesDic[this.id]].brand
    // if (this.brand == null || this.brand == undefined || this.brand == '') {
    //   this.brand = '/'
    // }
    // this.organisationid = this.gn.Vehicles[this.gn.VehiclesDic[this.id]].organisationid

    // for (let i = 0; i < this.gn.Vehicles.length; i++) {
    //   if (this.id == this.gn.Vehicles[i].vehicleid) {
    //     if (this.gn.Vehicles[i].organisationid == 0) {
    //       this.organisationname = this.dic.l['Ungroupped']
    //     } else {
    //       for (let j = 0; j < this.gn.Organisations.length; j++) {
    //         if (this.gn.Vehicles[i].organisationid == this.gn.Organisations[j].id && this.gn.Vehicles[i].organisationid != 0) {
    //           this.organisationname = this.gn.Organisations[j].name;
    //         }
    //       }
    //     }
    //   }
    // }
    // this.alias = this.gn.Vehicles[this.gn.VehiclesDic[this.id]].alias

    // this.proba = this.gn.Vehicles[this.gn.VehiclesDic[this.id]].allowultrasonic
    console.log(this.brand, 'daj da vidam proba')

    // {{gn.fInt(v.odometar)}} {{gn.user.metric}}
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InforeconstructionPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/reports/reconstrunction/inforeconstruction.ts